module.exports = __webpack_public_path__ + "media/photo/comminutions_man-78dee2c5.png";